export const BUILD_TIME = __BUILD_TIME__;

export const getVersionDisplay = (): string => {
  try {
    const d = new Date(BUILD_TIME);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');

    // Lightweight fingerprint from ISO timestamp (seconds + milliseconds)
    const hash = BUILD_TIME.slice(-7, -1);

    return `${yyyy}.${mm}.${dd}-${hh}${min} (${hash})`;
  } catch {
    return 'unknown';
  }
};

export const getVersionShort = (): string => {
  try {
    return BUILD_TIME.slice(0, 16);
  } catch {
    return 'Unknown';
  }
};
